import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=099c3c41&scoped=true&"
import script from "./orderInfo.vue?vue&type=script&lang=js&"
export * from "./orderInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=099c3c41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c3c41",
  null
  
)

export default component.exports